import { Component } from "@angular/core";

@Component({
  selector: "icon-ampliacion-seguro-alcancia",
  templateUrl: "./ampliacion-seguro-alcancia.svg",
  standalone: true,
})
export class AmpliacionSeguroAlcanciaComponent {}